/**
 * Resolves the billing tier for a company's plan (BIO-2000).
 *
 * `tierNumber` is honored when the caller has one from a trustworthy source
 * (the plan resolved out of the price-plans catalog). Today's call sites pass
 * `undefined` on purpose and use the anchored `_tN` suffix of the plan value,
 * which billing-service builds as `${priceId}_t${tierNumber}` — pulling the
 * catalog in would mean depending on `useCurrentPlan`, whose `useStore()`
 * throws when first evaluated during render and whose catalog snapshot is not
 * reactive (PR #4085 review).
 *
 * The match must stay anchored. The price id is a random Stripe alphanumeric,
 * so an unanchored match can read a decoy `t<digit>` out of the id itself
 * (`price_1Qt3abc_t5` is tier 5, not tier 3). A value with no tier suffix
 * resolves to `undefined`, never to 0 — not-yet-loaded and tier-zero must not
 * collapse into each other, because 0 drives `hideForT0` nav behaviour.
 */
export const resolvePlanTier = (
  tierNumber: number | null | undefined,
  planValue: string | null | undefined
): number | undefined => {
  if (tierNumber !== undefined && tierNumber !== null) {
    return tierNumber;
  }

  const match = planValue?.match(/_t(\d+)$/);

  return match ? Number(match[1]) : undefined;
};

export default resolvePlanTier;
